export default __webpack_public_path__ + "media/images/map/leaflet/images/marker-icon-2x-680f69f3c2e6b90c1812a813edf67fd7.png";